import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import DashboardLayout from '@/components/layouts/dashboard';
import ShipLoading from '@/components/ui/loader/ShipLoading';

export default function NotificationsPage() {
  const router = useRouter();

  useEffect(() => {
    router.replace('/dashboard#notification');
  }, [router]);

  return (
    <DashboardLayout>
      <div className="w-full flex items-center justify-center min-h-[50vh]">
        <ShipLoading label="Memuat notifikasi..." />
      </div>
    </DashboardLayout>
  );
}

export const Route = createFileRoute('/_authenticated/notifications')({
  component: NotificationsPage,
});
